import { useRef } from 'react';

declare global {
  var useIdValue: number;
}

/**
 * Generates a unique (stable) ID for a component. Should be replaced with React.useId once we support only React 18.
 */
export function useId(prefix: string) {
  if (globalThis.useIdValue === undefined) {
    globalThis.useIdValue = 0;
  }

  const id = useRef<string | undefined>(undefined);
  if (id.current === undefined) {
    id.current = `${prefix}-${globalThis.useIdValue++}`;
  }
  return id.current;
}
